import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/global';
import {FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';

@Component({
  selector: 'app-loan-amount-estimate',
  templateUrl: './loan-amount-estimate.component.html',
  styleUrls: ['./loan-amount-estimate.component.scss']
})
export class LoanAmountEstimateComponent implements OnInit {

  
  constructor(public globals: Globals) { }

  section_modal = 200000;

  ngOnInit() {
    const modal = this.globals.getModalValue();
    if (undefined !== modal) {
      this.section_modal = parseFloat(modal);
    }
  }

  setValue(value) {
    this.globals.setValue(value);
  }

  loanamountestimate = new FormControl('', [
    Validators.required
  ]);

}
